import { createModel } from "@rematch/core";
import { RootModel } from ".";
import { ReactNode } from "react";

interface State {
  show: boolean;
  title: string;
  text?: ReactNode;
  actions?: boolean;
  icon?: "success" | "error";
  actionIsLoading?: boolean;
}

const initialState: State = {
  show: false,
  title: "",
};

let resolveCallback: ((value: boolean | PromiseLike<boolean>) => void) | null =
  null;

export const alerts = createModel<RootModel>()({
  state: initialState,
  reducers: {
    show(_: State, options: Omit<State, "show">) {
      return { ...options, show: true };
    },

    close() {
      resolveCallback?.(false);
      return { ...initialState };
    },

    startLoader(state: State) {
      return { ...state, actionIsLoading: true };
    },
  },

  effects: () => ({
    async confirm(payload: { title: string; text?: string }) {
      this.show({ ...payload, actions: true });
      return new Promise<boolean>((res) => {
        resolveCallback = res;
      });
    },

    onConfirm() {
      this.startLoader();
      resolveCallback?.(true);
    },
  }),
});
